import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fa35f2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "product-detail" }
const _hoisted_3 = { class: "product-media" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductHeader = _resolveComponent("ProductHeader")!
  const _component_NameRedirect = _resolveComponent("NameRedirect")!
  const _component_ProductInformation = _resolveComponent("ProductInformation")!
  const _component_ProductImages = _resolveComponent("ProductImages")!
  const _component_ProductCarousel = _resolveComponent("ProductCarousel")!
  const _component_ProductButtons = _resolveComponent("ProductButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ProductHeader, { product: _ctx.product }, null, 8, ["product"]),
    _createVNode(_component_NameRedirect, { product: _ctx.product }, null, 8, ["product"]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ProductInformation, {
        product: _ctx.product,
        formatDecoins: _ctx.formatDecoins,
        checkProductIsActive: _ctx.checkProductIsActive,
        isProductOutOfStock: _ctx.isProductOutOfStock
      }, null, 8, ["product", "formatDecoins", "checkProductIsActive", "isProductOutOfStock"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProductImages, {
          product: _ctx.product,
          showImagesCarousel: _ctx.showImagesCarousel,
          currentSlide: _ctx.currentSlide,
          openImageModal: _ctx.openImageModal,
          class: "product-images"
        }, null, 8, ["product", "showImagesCarousel", "currentSlide", "openImageModal"]),
        _createVNode(_component_ProductCarousel, {
          product: _ctx.product,
          slideTo: _ctx.slideTo,
          class: "product-carousel"
        }, null, 8, ["product", "slideTo"])
      ])
    ]),
    _createVNode(_component_ProductButtons, {
      product: _ctx.product,
      hasEnoughDecoins: _ctx.hasEnoughDecoins,
      isProductOutOfStock: _ctx.isProductOutOfStock,
      checkEnough: _ctx.checkEnough,
      checkProductIsActive: _ctx.checkProductIsActive,
      addToBag: _ctx.addToBag,
      removeFromBag: _ctx.removeFromBag,
      bagIncludes: _ctx.bagIncludes,
      setButtonText: _ctx.setButtonText,
      isFavorite: _ctx.isFavorite
    }, null, 8, ["product", "hasEnoughDecoins", "isProductOutOfStock", "checkEnough", "checkProductIsActive", "addToBag", "removeFromBag", "bagIncludes", "setButtonText", "isFavorite"])
  ]))
}